export default "__VITE_ASSET__a311f7e3__"